import React, {Component} from 'react';
import {Router, Route, Switch} from 'react-router-dom';
import history from './history';

import AuthRoute from './components/layoutComponents/AuthRoute';
import PageNotFound from './components/layoutComponents/404';
import LoginPage from './components/authenticationComponents/LoginPage';
import VerifyLoginPage from './components/authenticationComponents/VerifyLoginPage';
import PasswordResetPage from './components/authenticationComponents/PasswordResetPage';
import PasswordRecoveryPage from './components/authenticationComponents/PasswordRecoveryPage';
import Layout from './components/layoutComponents/Layout';
import ExternalUserContainer from './components/layoutComponents/ExternalUserContainer';
import ErrorBoundary from './components/commonComponents/util/ErrorBoundary';


export default class App extends Component {
    render() {
        return (
            <ErrorBoundary>
                <Router history={history}>
                    <Switch>
                        <AuthRoute exact path="/404" component={PageNotFound}/>
                        <AuthRoute exact path="/login" component={LoginPage}/>
                        <AuthRoute exact path="/verify-login" component={VerifyLoginPage}/>
                        <AuthRoute exact path="/recover-password" component={PasswordRecoveryPage}/>
                        <AuthRoute exact path="/reset-password" component={PasswordResetPage}/>
                        <AuthRoute exact path="/set-password" component={PasswordResetPage}/>
                        <Route exact path="/external-lists/:id" component={ExternalUserContainer}/>
                        <AuthRoute path="/" component={Layout}/>
                    </Switch>
                </Router>
            </ErrorBoundary>
        );
    }
}


// WEBPACK FOOTER //
// ./src/App.js